import { medalIcon } from '@/images'
import { GxIcon } from '@garpix/garpix-web-components-react'
import classNames from 'classnames'
import React from 'react'
import { Link } from 'react-router-dom'
import style from './styles/tournament.module.scss'

interface IProps {
  title: string
  description: string
  date: string
  url: string
  finished: string
  registerClosed: string
  stage: string | null
}

const TournamentCard = ({
  title,
  description,
  date,
  url,
  finished,
  registerClosed,
  stage
}: IProps): React.ReactElement => {
  const isFinish = Boolean(Number(finished))
  const isWaiting = Boolean(Number(registerClosed)) && !isFinish
  const isOpen = !isWaiting && !isFinish

  const slicedDate =
  date !== '' ? date.slice(0, 10) : ''

  return (
    <Link to={url} className={style.card}>
      <div
        className={classNames({
          [style.card_status]: true,
          [style.card_status__open]: isOpen,
          [style.card_status__completed]: isFinish,
          [style.card_status__waiting]: isWaiting
        })}
      >
        <GxIcon src={medalIcon} className={style.card_status__icon} />
        <span className={style.card_status__text}>
          {isOpen ? 'Открыт набор' : ''}
          {isFinish ? 'Завершен' : ''}
          {isWaiting ? 'Ожидание завершения' : ''}
        </span>

        {stage !== null
          ? (
            <span className={style.card_status__stage}>{stage}</span>
            )
          : null}

        {isWaiting
          ? (
            <span className={style.card_status__date}>{slicedDate}</span>
            )
          : null}
      </div>

      <div className={style.card_content}>
        <p className={style.card__title}>{title}</p>
        <p className={style.card__text}>{description}</p>
      </div>
    </Link>
  )
}

export default TournamentCard
